import { Component, Input } from '@angular/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { TranslateService } from '@ngx-translate/core';
import { NetworkService } from '../networking-vcd.service';
import { VcaAlertsService } from '../../../../../common/vca-alerts/vca-alerts.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
    selector: 'networking-vcd-dashboard',
    providers: [NetworkService, TranslateService],
    styles: [require('../networking-vcd.scss')],
    template: require('./networking-vcd-dashboard.html')
})
export class NetworkingDashboard {

    @Input() isActivityLogVisible: boolean = false;
    private edgeCount: number = 0;
    private computeNetworkCount: number = 0;
    private directConnectCount: number = 0;
    private internetNetworkCount: number = 0;
    private transitNetworkCount: number = 0;
    private publicFreeIps: number = 0;
    private publicTotalIps: number = 0;
    private directConnectFreeIps: number = 0;
    private directConnectTotalIps: number = 0;
    private internetNetworkIds: Array<string> = [];
    private directConnectIds: Array<string> = [];
    private publicIpPieChartData: any;
    private ipPieChartOptions: any;
    private directConnectIpPieChartData: any;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private loaded: boolean = false;

    constructor(private service: NetworkService, 
                private translateService: TranslateService,
                private alert: VcaAlertsService,
                private rss: RefreshSharedService) {
        translateService.use(GlobalVariables.LOCALE);
        this.ipPieChartOptions = {
            scaleShowVerticalLines: true,
            responsive: true,
            legend: {
                display: false,
                position: 'left'
            },
            cutoutPercentage: 75
        };
        this.rsService = rss;
        this.currentClassName = 'NetworkingDashboard';  
    };

    ngOnChanges() {
        if (!this.isActivityLogVisible) {
           this.rsService.setParam({
              'loadedComponent': this.currentClassName, 
              'detailPageIDName': '',
              'shouldReloadInventoryTree': false
            });
        }
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });
        this.rsService.setParam({
            'loadedComponent': this.currentClassName, 
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        this.getDashboardData();
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            this.getDashboardData();
        }
    }

    getDashboardData() {
        this.loaded = false;
        this.service.getDirectConnectList()
            .subscribe(
                (data: any) => {
                    if (data) {
                        this.directConnectCount = data.length;
                        this.loaded = true;
                    }
                },
                error => {
                    this.alert.danger(
                        [this.translateService.instant('networkDashboard.directConnectRetrieveError'), error],
                        'get-calls-error-alert');
                        this.loaded = true;
                }
            );

        this.service.getVDCNetworkList()
            .subscribe(
                (data: any) => {
                    if (data) {
                        this.computeNetworkCount = data.length;
                        this.loaded = true;
                    }
                },
                error => {
                    this.alert.danger(
                        [this.translateService.instant('networkDashboard.vdcNetworkRetrieveError'), error],
                        'get-calls-error-alert');
                        this.loaded = true;
                }
            );

        this.service.getAllGateways()
            .subscribe(
                (data: any) => {
                    let gateways: Array<any> = data;
                    if (gateways) {
                        this.edgeCount = gateways.length;
                    }
                },
                error => {
                    this.alert.danger(
                        [this.translateService.instant('networkDashboard.gatewayRetrieveError'), error],
                        'get-calls-error-alert');
                }
            );
    }

    ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vcd/dashboard/networking-vcd-dashboard.component.ts